import React, { useEffect, useState } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import PollResultChart from '../../../../layout/PublicLayout/Components/Polls/PollResult/PollResultChart.jsx';
import { AppBarCMS } from '../../../../basic';
import { RadioButtonsPicker } from '../../../../common/form/FormElements';
import PollTableResults from './PollTableResults.jsx';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useGetPollQuery,
  useSaveResultsPublicMutation,
} from '../../../../../redux/services/polls';
import { Col, Form, Row } from 'antd';
import FormSwitch from '../../../../antd/form/FormSwitch/FormSwitch.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const PollsResults = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [display, setDisplay] = useState('chart');

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = t('Výsledky ankety') + ' - FRI CMS';
  }, []); // Runs on mount

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { data: pollDetail, isLoading: pollLoading } = useGetPollQuery(id);
  const [saveResultsPublic, { isSuccess: saveSuccess }] =
    useSaveResultsPublicMutation();

  const handleChange = (checked) => {
    saveResultsPublic({ id: pollDetail.id, checked: checked });
  };

  useEffect(() => {
    if (saveSuccess) {
      showSaveSuccess();
    }
  }, [saveSuccess]);

  return !isCreate && pollLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Výsledky ankety') + ' ' + pollDetail.name}
        backUrl={routes.cmsPolls}
        backUrlTooltip={t('Ankety')}
        permissionsBasic={'polls'}
      />
      <div style={{ margin: '10px' }}>
        <>
          {pollDetail && pollDetail.id && (
            <CollapseBlock
              collapsible
              collapse={false}
              title={t('Výsledky hlasovania')}
            >
              <div style={{ marginLeft: '20px' }}>
                <RadioButtonsPicker
                  items={[
                    { id: 'chart', name: 'chart', label: t('Graf') },
                    { id: 'table', name: 'table', label: t('Tabuľka') },
                  ]}
                  value={display}
                  defaultId="chart"
                  onChange={(value) => setDisplay(value)}
                />
              </div>
              <Row>
                <Col>
                  <Form
                    initialValues={{ show_results: pollDetail.show_results }}
                  >
                    <FormSwitch
                      label={t(
                        'Zobraziť výsledky hlasovania aj na stránke ankety',
                      )}
                      name={'show_results'}
                      onChange={handleChange}
                    />
                  </Form>
                </Col>
              </Row>

              {display === 'chart' ? (
                <PollResultChart pollId={pollDetail.id} />
              ) : (
                <PollTableResults pollId={pollDetail.id} />
              )}
            </CollapseBlock>
          )}
        </>
      </div>
    </>
  );
};

export default PollsResults;
